import styled from 'styled-components'
import { useShowDialog } from '../../App'
import { theme } from '../../styles/theme'
import { PrimaryButton, SecondaryButton } from '../Button/Button'
import { Column, Row } from '../Table/Table'
import { BodyText, Heading1 } from '../Typography/Typography'

const StyledDialog = styled.div`
    display: inline-block;
    background: ${theme.colors.White};
    border-radius: ${theme.radii.medium};
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 550px;
    padding: 3em;
` 

const DialogGlass = styled.div`
    position: absolute;
    inset: 0;
    background-color: ${theme.colors.Black}60;
    z-index: 200;
`

export interface DialogProps {
    title?: string
    text?: string
    confirmText?: string
    content?: JSX.Element
    onConfirmed?: VoidFunction
    onCancelled?: VoidFunction
}
export const Dialog = ({ title, text, content, confirmText = 'OK', onConfirmed, onCancelled }: DialogProps) => {
  const showDialog = useShowDialog()
  const hideDialog = () => { showDialog(null) }
  return (
    <DialogGlass>
      <StyledDialog>
        <Column style={{ alignItems: 'center'}}>
          {content ?? (
            <>
              <Heading1>{ title }</Heading1>
              <BodyText>{ text }</BodyText>
            </>
          )}
          <Row style={{ marginTop: '2em', gap: '3em' }}>
             { onCancelled && <SecondaryButton {...{
              text: 'cancel',
              onClick: () => {
                hideDialog()
                onCancelled?.()
              }
            }} /> }
            { onConfirmed && <PrimaryButton {...{ 
              text: confirmText,
              onClick: () => {
                hideDialog()
                onConfirmed()
              }
            }} /> }
        </Row>
        </Column>
      </StyledDialog>
  </DialogGlass>
  )
}